import { deleteDomainCookie, readDomainCookie, writeDomainCookie } from '@/lib/domain_cookie';

export const TRUSTED_CAREGIVER_INVITE_SNOOZE_COOKIE_PREFIX = 'tc_invite_remind_until';
export const TRUSTED_CAREGIVER_INVITE_SNOOZE_DAYS = 1;

export function trustedCaregiverInviteSnoozeCookieName(accountId: string | number): string {
  return `${TRUSTED_CAREGIVER_INVITE_SNOOZE_COOKIE_PREFIX}-${accountId}`;
}

/** Persist when the invite popup may show again (now + 24h) via domain cookie helpers. */
export function snoozeTrustedCaregiverInvite(accountId: string | number, now = new Date()): Date {
  const until = new Date(now);
  until.setDate(until.getDate() + TRUSTED_CAREGIVER_INVITE_SNOOZE_DAYS);

  writeDomainCookie(trustedCaregiverInviteSnoozeCookieName(accountId), until.toISOString(), { expires: until });
  return until;
}

/** True while the cookie's show-again time is still in the future. */
export function isTrustedCaregiverInviteSnoozed(accountId: string | number, now = Date.now()): boolean {
  const name = trustedCaregiverInviteSnoozeCookieName(accountId);
  const raw = readDomainCookie(name);
  if (!raw) return false;

  const until = Date.parse(raw);
  if (Number.isNaN(until) || now >= until) {
    deleteDomainCookie(name);
    return false;
  }

  return true;
}
